import axios from 'axios';
import Cookies from 'js-cookie';
import store from '@/store';
import router from '@/router';

axios.defaults.withCredentials = true;

const http = (window.http = axios.create({
    baseURL: process.env.VUE_APP_API_URL + 'api/v1',
}));
const bearer = Cookies.get('access_token');

if (bearer) {
    http.defaults.headers.common.Authorization = bearer;
}

http.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
http.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// Handle an Unauthenticated API response by logging the user out of the application.
http.interceptors.response.use(
    (resp) => resp,
    (error) => {
        // TODO(What about 403's? Also log them out???)
        if (error.response && error.response.status === 401) {
            store.commit('Auth/authLogout');

            if (router.currentRoute.path !== '/') {
                router.push('/');
            }
        } else {
            console.error('oops', error);
        }
        return Promise.reject(error);
    }
);

export default http;
